// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-main-loader {
    background: #101010;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
}

.admin-main-loader img {
    width: 50px;
}
.form-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000000bd;
    z-index: 9999;
    display: none;
}
.form-loader svg {
    width: 90px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.form-loader.show {
    display: block;
}
.react-pagination {
    display: flex;
    align-items: center;
}
.react-pagination button {
    padding: 5px 10px;
    margin: 0 4px;
    border: 1px solid #bdbdbd;
    color: #008c44;
    outline: none;
}
.react-pagination button:hover {
    background: #008c44;
    color: #fff;
    border-color: #008c44;
}
.btn {
    min-width: 40px;
}
.btn:active, .btn:focus, .btn:hover {
    outline: none;
    box-shadow: none;
    box-shadow: none;
    outline: none;
}
.btn-primary {
    background: #03396c;
    border-color: #03396c;
}

.btn-primary:hover {
    background: #ed716c;
    border-color: #ed716c;
    /* color: #000; */
}

.input-group-text {
    color: #03396c;
}
.logo-brand {
    max-height: 70px;
}
.badge {
    font-size: 11px;
    font-weight: 600;
    padding: 5px 9px;
}
.field-loader {
    background: #ededed;
    height: 40px;
    width: 100%;
    border-radius: 5px;
    animation: loader 1s infinite linear;
}
@keyframes loader{
    0%{background: #ededed}
    50%{background: #d7d7d7}
    100%{background: #ededed}
}
#menu li ul a.active {
    background: #3e3e3e;
}
#menu li ul a.active:hover {
    color: #fff;
}
.table tbody > tr > td img {
    width: 80px;
}
.cke_browser_webkit.cke_reset {
    width: 100%;
}
textarea.form-control {
    height: 150px;
    resize: none;
}

.custom-file-upload-wrapper{
    width: 100%;
    display: flex;
    align-items: center;
}

.custom-file-upload-wrapper span{
    cursor: pointer;
    color: #212529;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-right: none;
    padding: 10px 20px;
    border-radius: 4px 0 0 4px;
}

.custom-file-upload{
    /* flex: 1 1 0%; */
    padding: 10px 20px;
    cursor: pointer;
    color: #212529;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: 0 4px 4px 0;
}
.custom-file-preview {
    padding-left: 10%;
    /* flex: 1 1 0%;  */
}


.pagination-seller-journey {
    display: inline-block;
  }

     /* Custom styles for chip container */
.chip-container {
    padding-left: 3px;
    display: flex;
    flex-wrap: wrap;
    /* gap: 5px; /*space between chips */
    /* margin-bottom: 10px; space below the chip container */
    align-items: center;
  }
  
  /* Styles for individual chips */
  .chip {
    align-items: center;
    background-color: rgb(229 231 235 ); /* Light gray background */
    border-radius: 5px; /* Rounded corners */
    padding: 3px 8px 3px 8px; /* Space inside the chip */
    color: #333; /* Text color */
    /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
    height: 25px;
    font-size: 12px;
    margin-left: 2px;
   }
  
  .chip i {
    font-size: 10px;
    cursor: pointer; /* Pointer cursor on hover */
    color: #d9534f; /* Red color for the close icon */
  }


.no-hover-effect:focus {
    color: #212529;
    background-color: #fff;
    border-style: none !important;
    outline: 0;
    box-shadow: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,GAAG,mBAAmB;IACtB,IAAI,mBAAmB;IACvB,KAAK,mBAAmB;AAC5B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,0BAA0B;AAC9B;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,qBAAqB;EACvB;;KAEG,qCAAqC;AAC1C;IACI,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oCAAoC;IACpC,wDAAwD;IACxD,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE,mBAAmB;IACnB,mCAAmC,EAAE,0BAA0B;IAC/D,kBAAkB,EAAE,oBAAoB;IACxC,wBAAwB,EAAE,0BAA0B;IACpD,WAAW,EAAE,eAAe;IAC5B,2CAA2C;IAC3C,YAAY;IACZ,eAAe;IACf,gBAAgB;GACjB;;EAED;IACE,eAAe;IACf,eAAe,EAAE,4BAA4B;IAC7C,cAAc,EAAE,iCAAiC;EACnD;;;AAGF;IACI,cAAc;IACd,sBAAsB;IACtB,6BAA6B;IAC7B,UAAU;IACV,2BAA2B;AAC/B","sourcesContent":[".admin-main-loader {\n    background: #101010;\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.admin-main-loader img {\n    width: 50px;\n}\n.form-loader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #000000bd;\n    z-index: 9999;\n    display: none;\n}\n.form-loader svg {\n    width: 90px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.form-loader.show {\n    display: block;\n}\n.react-pagination {\n    display: flex;\n    align-items: center;\n}\n.react-pagination button {\n    padding: 5px 10px;\n    margin: 0 4px;\n    border: 1px solid #bdbdbd;\n    color: #008c44;\n    outline: none;\n}\n.react-pagination button:hover {\n    background: #008c44;\n    color: #fff;\n    border-color: #008c44;\n}\n.btn {\n    min-width: 40px;\n}\n.btn:active, .btn:focus, .btn:hover {\n    outline: none;\n    box-shadow: none;\n    box-shadow: none;\n    outline: none;\n}\n.btn-primary {\n    background: #03396c;\n    border-color: #03396c;\n}\n\n.btn-primary:hover {\n    background: #ed716c;\n    border-color: #ed716c;\n    /* color: #000; */\n}\n\n.input-group-text {\n    color: #03396c;\n}\n.logo-brand {\n    max-height: 70px;\n}\n.badge {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 5px 9px;\n}\n.field-loader {\n    background: #ededed;\n    height: 40px;\n    width: 100%;\n    border-radius: 5px;\n    animation: loader 1s infinite linear;\n}\n@keyframes loader{\n    0%{background: #ededed}\n    50%{background: #d7d7d7}\n    100%{background: #ededed}\n}\n#menu li ul a.active {\n    background: #3e3e3e;\n}\n#menu li ul a.active:hover {\n    color: #fff;\n}\n.table tbody > tr > td img {\n    width: 80px;\n}\n.cke_browser_webkit.cke_reset {\n    width: 100%;\n}\ntextarea.form-control {\n    height: 150px;\n    resize: none;\n}\n\n.custom-file-upload-wrapper{\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.custom-file-upload-wrapper span{\n    cursor: pointer;\n    color: #212529;\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n    border-right: none;\n    padding: 10px 20px;\n    border-radius: 4px 0 0 4px;\n}\n\n.custom-file-upload{\n    /* flex: 1 1 0%; */\n    padding: 10px 20px;\n    cursor: pointer;\n    color: #212529;\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n    border-radius: 0 4px 4px 0;\n}\n.custom-file-preview {\n    padding-left: 10%;\n    /* flex: 1 1 0%;  */\n}\n\n\n.pagination-seller-journey {\n    display: inline-block;\n  }\n\n     /* Custom styles for chip container */\n.chip-container {\n    padding-left: 3px;\n    display: flex;\n    flex-wrap: wrap;\n    /* gap: 5px; /*space between chips */\n    /* margin-bottom: 10px; space below the chip container */\n    align-items: center;\n  }\n  \n  /* Styles for individual chips */\n  .chip {\n    align-items: center;\n    background-color: rgb(229 231 235 ); /* Light gray background */\n    border-radius: 5px; /* Rounded corners */\n    padding: 3px 8px 3px 8px; /* Space inside the chip */\n    color: #333; /* Text color */\n    /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */\n    height: 25px;\n    font-size: 12px;\n    margin-left: 2px;\n   }\n  \n  .chip i {\n    font-size: 10px;\n    cursor: pointer; /* Pointer cursor on hover */\n    color: #d9534f; /* Red color for the close icon */\n  }\n\n\n.no-hover-effect:focus {\n    color: #212529;\n    background-color: #fff;\n    border-style: none !important;\n    outline: 0;\n    box-shadow: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
